import * as Yup from 'yup';
import { NonUsFinancialAccountsStateValues } from './slice';

export const fields: IBaseField<keyof NonUsFinancialAccountsStateValues>[] = [
  {
    name: 'atAnyTimeDuringYearDidYouOwnAFinancialAccountsuchAsBankSavingsRetirementOrBrokerageAccountOutsideTheUnitedStates',
    label:
      'At any time during Year, did you own a financial account (such as bank, savings, retirement or brokerage account) outside the United States?\nChecking, Savings, Retirement, Brokerage, etc',
    type: 'radio',
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'atAnyPointDuringYearWasTheSumAcrossAllYourNonUsFinancialAccountsOverUsd10000',
        label:
          'At any point during Year, was the sum across all your non-US financial accounts over USD 10,000?',
        subLabel: () => (
          <p>
            Don’t forget your pension! $10k or more barrier means across ALL
            non-US financial accounts
          </p>
        ),
        type: 'radio',
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
        dependencies: [
          {
            name: 'doYouWantTfxToPrepareYourFbar',
            label: 'Do you want Us to prepare your FBAR?',
            type: 'radio',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            dependencies: [
              {
                name: 'iHaveBeenAdvisedThatThoseWhoHaveNonUsFinancialAccountsValuedOver10000NeedToFileFormsFinCen114fbarAndorForm8938fatcaThereArePotentiallySevereConsequencesStemmingFromFailureToFileTheseFormsWithTheIrstreasury',
                label: () => (
                  <div>
                    <p>
                      I have been advised that those who have non-US financial
                      accounts valued over $10,000 need to file Forms FinCEN 114
                      (FBAR) and/or Form 8938 (FATCA). There are potentially
                      severe consequences stemming from failure to file these
                      forms with the IRS/Treasury
                    </p>
                    <p>Check the box to confirm</p>
                  </div>
                ),
                type: 'checkbox',
                predicate: (value) => value === 'no',
                tooltip: '',
                comment: true,
              },
            ],
          },
          {
            name: 'whichOfTheFollowingBestDescribesYourFilingStatus',
            label: 'Which of the following best describes your Filing Status:',
            subLabel: () => (
              <p>Your owned real estate does not count as a financial asset</p>
            ),
            type: 'select',
            options: [
              {
                label:
                  'Unmarried or married filing separately, residing outside the United States',
                value:
                  'Unmarried or married filing separately, residing outside the United States',
              },
              {
                label:
                  'Married filing jointly, residing outside the United States',
                value:
                  'Married filing jointly, residing outside the United States',
              },
              {
                label: 'Married filing jointly, residing in the United States',
                value: 'Married filing jointly, residing in the United States',
              },
              {
                label:
                  'Unmarried or married filing separately, residing in the United States',
                value:
                  'Unmarried or married filing separately, residing in the United States',
              },
            ],
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            dependencies: [
              {
                name: 'didYouHaveOver300000InNonUsFinancialAssetsDuringYear',
                label:
                  'Did you have over $300,000 in non-US financial assets during Year?',
                subLabel: () => (
                  <p>
                    This includes interest in a foreign entity
                    (corporation/partnership/trust)
                  </p>
                ),
                type: 'radio',
                predicate: (value) =>
                  value ===
                  'Unmarried or married filing separately, residing outside the United States',
                tooltip: '',
                comment: true,
                dependencies: [
                  {
                    type: 'information',
                    label: () => (
                      <p>
                        Based on your answers, you are required to file FBAR
                        (FinCEN 114) and FATCA (Form 8938)
                      </p>
                    ),
                    predicate: (value) => value === 'yes',
                  },
                ],
              },
              {
                name: 'didYouHaveOver200000AcrossAllNonUsAccountsOnDec31Year',
                label:
                  'Did you have over $200,000 across all non-US accounts on Dec-31-Year?',
                subLabel: () => (
                  <p>
                    This includes interest in a foreign entity
                    (corporation/partnership/trust)
                  </p>
                ),
                type: 'radio',
                predicate: (value) =>
                  value ===
                  'Unmarried or married filing separately, residing outside the United States',
                tooltip: '',
                comment: true,
              },
              {
                name: 'didYouHaveOver600000InNonUsFinancialAssetsDuringYear',
                label:
                  'Did you have over $600,000 in non-US financial assets during Year?',
                subLabel: () => (
                  <p>
                    This includes interest in a foreign entity
                    (corporation/partnership/trust)
                  </p>
                ),
                type: 'radio',
                predicate: (value) =>
                  value ===
                  'Married filing jointly, residing outside the United States',
                tooltip: '',
                comment: true,
                dependencies: [
                  {
                    label: () => (
                      <p>
                        Based on your answers, you are required to file FBAR
                        (FinCEN 114) and FATCA (Form 8938)
                      </p>
                    ),
                    type: 'information',
                    predicate: (value) => value === 'yes',
                  },
                ],
              },
              {
                name: 'didYouHaveOver400000AcrossAllNonUsAccountsOnDec31Year',
                label:
                  'Did you have over $400,000 across all non-US accounts on Dec-31-Year?',
                subLabel: () => (
                  <p>
                    This includes interest in a foreign entity
                    (corporation/partnership/trust)
                  </p>
                ),
                type: 'radio',
                predicate: (value) =>
                  value ===
                  'Married filing jointly, residing outside the United States',
                tooltip: '',
                comment: true,
              },
              {
                name: 'didYouHaveOver150000InNonUsFinancialAssetsDuringYear',
                label:
                  'Did you have over $150,000 in non-US financial assets during Year',
                subLabel: () => (
                  <p>
                    This includes interest in a foreign entity
                    (corporation/partnership/trust)
                  </p>
                ),
                type: 'radio',
                predicate: (value) =>
                  value ===
                  'Married filing jointly, residing in the United States',
                tooltip: '',
                comment: true,
                dependencies: [
                  {
                    label: () => (
                      <p>
                        Based on your answers, you are required to file FBAR
                        (FinCEN 114) and FATCA (Form 8938)
                      </p>
                    ),
                    type: 'information',
                    predicate: (value) => value === 'yes',
                  },
                ],
              },
              {
                name: 'didYouHaveOver100000AcrossAllNonUsAccountsOnDec31Year',
                label:
                  'Did you have over $100,000 across all non-US accounts on Dec-31-Year',
                subLabel: () => (
                  <p>
                    This includes interest in a foreign entity
                    (corporation/partnership/trust)
                  </p>
                ),
                type: 'radio',
                predicate: (value) =>
                  value ===
                  'Married filing jointly, residing in the United States',
                tooltip: '',
                comment: true,
              },
              {
                name: 'didYouHaveOver75000InNonUsFinancialAssetsDuringYear',
                label:
                  'Did you have over $75,000 in non-US financial assets during Year?',
                subLabel: () => (
                  <p>
                    This includes interest in a foreign entity
                    (corporation/partnership/trust)
                  </p>
                ),
                type: 'radio',
                predicate: (value) =>
                  value ===
                  'Unmarried or married filing separately, residing in the United States',
                tooltip: '',
                comment: true,
                dependencies: [
                  {
                    label: () => (
                      <p>
                        Based on your answers, you are required to file FBAR
                        (FinCEN 114) and FATCA (Form 8938)
                      </p>
                    ),
                    type: 'information',
                    predicate: (value) => value === 'yes',
                  },
                ],
              },
              {
                name: 'didYouHaveOver50000AcrossAllNonUsAccountsOnDec31Year',
                label:
                  'Did you have over $50,000 across all non-US accounts on Dec-31-Year?',
                subLabel: () => (
                  <p>
                    This includes interest in a foreign entity
                    (corporation/partnership/trust)
                  </p>
                ),
                type: 'radio',
                predicate: (value) =>
                  value ===
                  'Unmarried or married filing separately, residing in the United States',
                tooltip: '',
                comment: true,
              },
            ],
          },
        ],
      },
      {
        name: 'howManyFinancialAccountsOutsideTheUSDidYouOwnOrHaveSignatoryAuthorityDuringTheFilingYear',
        label:
          'How many financial accounts outside the U.S. did you own or have signatory authority during the filing year?',
        subLabel: () => (
          <p>
            Don't forget pensions! Refers to ALL Financial accounts outside the
            U.S.
          </p>
        ),
        type: 'select',
        options: Array.from({ length: 25 })
          .map((_, i) => (i + 1).toString())
          .concat('25+')
          .map((num) => ({ label: num, value: num })),
        predicate: (value) => value === 'yes',
        tooltip: '',
        comment: true,
      },
    ],
  },

  {
    name: 'didYouOwnMoreThan50OfACorporationThatHasANonUsBankAccount',
    label:
      'Did you own more than 50% of a corporation that has a non-US bank account?',
    type: 'radio',
    tooltip: '',
    comment: true,
  },
  {
    name: 'areYouAnOwnerfullOrPartialOfANonUsTrust',
    label: 'Are you an owner (full or partial) of a non-US trust?',
    type: 'radio',
    tooltip: '',
    comment: true,
  },
  {
    name: 'areYouABeneficiaryOfANonUsTrust',
    label: 'Are you a beneficiary of a non-US trust?',
    type: 'radio',
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouReceiveSellSendExchangeOrOtherwiseAcquireAnyFinancialInterestInAnyVirtualCurrency',
    label:
      'Did you receive, sell, send, exchange, or otherwise acquire any financial interest in any virtual currency?',
    type: 'radio',
    tooltip: '',
    comment: true,
    dependencies: [
      {
        label: () => (
          <p>Please reflect these transactions in the investments section.</p>
        ),
        type: 'information',
        predicate: (value) => value === 'yes',
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
